import uniq from 'lodash/uniq';
import { ITEM_KINDS, ITEM_STATUSES } from '@updater-core/constants/items';
import { Item, Declined } from './types.d';

const statusOrder = [
  ITEM_STATUSES.CANCELLED,
  ITEM_STATUSES.ALREADY_DONE,
  ITEM_STATUSES.NOT_NEEDED,
  ITEM_STATUSES.COMPLETED,
  ITEM_STATUSES.UNVERIFIED,
  ITEM_STATUSES.VALIDATING,
  ITEM_STATUSES.PENDING,
];

function extractForwardMailStep(items) {
  const forwardMailItems = items
    .filter((item) => item.kind === ITEM_KINDS.FORWARD_MAIL)
    .sort(
      (a, b) => statusOrder.indexOf(b.status) - statusOrder.indexOf(a.status)
    );
  return forwardMailItems[0] || {};
}

export function mergeItemsAndDeclines(items: Item[], declined: Declined) {
  // TODO: This does not take into account "NOT_NEEDED"
  const alreadyKinds = declined?.already_done || [];
  const itemKinds = items.map(({ kind }) => kind);

  const kinds = uniq([...alreadyKinds, ...itemKinds]);

  const newItems = kinds.reduce((mergedItems, kind) => {
    const item = items.find((it) => it.kind === kind);

    // Note: This logic is needed because unlike other steps,
    // FYM can have multiple items
    if (kind === ITEM_KINDS.FORWARD_MAIL) {
      const forwardMailStep = extractForwardMailStep(items);

      if (alreadyKinds.includes(ITEM_KINDS.FORWARD_MAIL)) {
        forwardMailStep.status = ITEM_STATUSES.ALREADY_DONE;
      }

      return {
        ...mergedItems,
        [kind]: {
          ...forwardMailStep,
          id: item?.id,
        },
      };
    }

    const statuses = [item?.status];

    if (alreadyKinds.includes(item?.kind)) {
      statuses.push(ITEM_STATUSES.ALREADY_DONE);
    }

    statuses.sort((a, b) => statusOrder.indexOf(b) - statusOrder.indexOf(a));

    return {
      ...mergedItems,
      [kind]: {
        kind,
        metadata: item?.metadata,
        id: item?.id,
        status: statuses[0],
        status_updated_at: item?.status_updated_at,
      },
    };
  }, {});

  return newItems;
}
